export default __webpack_public_path__ + "static/media/biznet.a8ae039b.png";